import ConfigServices from "./Config.services.js";

class MarketExplorerServices {
  
  loadMarketExplorerListConfig() {
    return ConfigServices.loadMarketExplorerListConfig()
  }

  getMarketExplorerList() {
    return ConfigServices.getMarketExplorerList();
  }

}
export default new MarketExplorerServices();
